import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {RouteService} from '../../../services/route/route.service';
import {SnackService} from '../../../services/snack/snack.service';
import {ViewService} from '../../../services/view/view.service';
import {ProxiedUsersService} from "../../../services/proxy/proxy.service";
import {AuthService} from '../../../services/auth/auth.service';
import {tap} from 'rxjs';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./../login.component.scss']
})
export class ConfirmEmailComponent implements OnInit {
  public isLoading: boolean;
  public confirmationSucceed: boolean;
  private uuid: string;

  constructor(
    private usersService: ProxiedUsersService,
    private routeService: RouteService,
    private translateService: TranslateService,
    private snackService: SnackService,
    private authService: AuthService,
    public viewService: ViewService) {}

  public ngOnInit(): void {
    this.isLoading = true;
    if (this.routeService.params['uuid']) {
      this.uuid = this.routeService.params['uuid'];
    } else {
      this.authService.navigateToBaseUrl();
    }
    if (this.uuid) {
      this.confirmEmail();
    }
  }

  public confirmEmail(): void {
    this.usersService.confirmNewEmail(this.uuid).pipe(
      tap({error: (e) => {
        let keepSpinner = false;
        if (e.error?.message === 'api_uuid_validation_error') {
          keepSpinner = true;
        }
        if (e.error?.message === 'api_users_user_not_found') {
          keepSpinner = true;
        }
        if (!keepSpinner) {
          this.isLoading = false;
          this.snackService.showBackendError(e);
        } else {
          this.routeService.navigate('/').then(() => {
            this.snackService.showBackendError(e);
          });
        }
      }})
    ).subscribe((res) => {
      if (res) {
        this.authService.loginSuccessObs(res).subscribe();
        this.isLoading = false;
        this.confirmationSucceed = true;
        this.authService.navigateToBaseUrl().then(() => {
          this.snackService.showSuccess(this.translateService.instant('general.api_email_confirmation_success'));
        });
      }
    })
  }
}
